import styled from "styled-components";
import {
  EXPANDED_SIDEBAR_WIDTH,
  HEADER_BAR_HEIGHT
} from "../../constants/fixedStyleVariables";

export const SettingContainer = styled.div`
  margin-top: ${HEADER_BAR_HEIGHT}px;
  margin-right: ${EXPANDED_SIDEBAR_WIDTH}px;
  //{prev v
    // height: calc(100vh - ${HEADER_BAR_HEIGHT}px);
  //position: relative;
  //}
  // new v {
  position: fixed;
  width: calc(100% - ${EXPANDED_SIDEBAR_WIDTH}px);
  top: 0;
  //}
`;
export const SettingInnerContainer = styled.div`
  width: 100%;
  padding: 60px 90px;
  //height: inherit; //prev v
  height: calc(100vh - ${HEADER_BAR_HEIGHT}px); //new v
  overflow-y: auto;
`;
